export function buildNewsListTableHeaders({ t }) {
  return [
    {
      value: "name",
      text: t("page.customers.title"),
      thClass: "w-[14rem]",
      tdClass: "max-w-[14rem] min-w-[10rem]",
      disabled: true,
    },
    {
      value: "status",
      text: t("page.dealersCompany.status"),
      thClass: "w-[10rem]",
      tdClass: "max-w-[12rem] min-w-[10rem]",
    },
    {
      value: "publishedAt",
      text: t("page.mutualSettlementsList.date"),
      thClass: "w-[10rem]",
      tdClass: "max-w-[12rem] min-w-[10rem]",
    },
  ];
}
